module.exports = __webpack_public_path__ + "img/icon-navigation-collapse.c6322b0e.svg";